import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'logged_out_retailers-filter_pill_row-view';

/**
 * This event tracks when users have viewed the filter pill row on the search/discover page, and what filters were listed there
 */
export function trackLoggedOutRetailersFilterPillRowView(
  filters: string,
  url2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { filters, url2 },
  });
}
